import { createSlice } from "@reduxjs/toolkit";

const drmCreateTableDataSlice = createSlice({
  name: "createDrmTable",
  initialState: {
    isLoading: false,
    errorMessage: undefined,
    successMessage: undefined,
  },
  reducers: {
    setCreateDrmTableData: (state) => {
      state.isLoading = true;
    },
    setCreateDrmTableDataSuccess: (state, action) => {
      state.isLoading = false;
      state.successMessage = action.payload;
    },
    setCreateDrmTableDataFailure: (state, action) => {
      state.isLoading = false;
      state.errorMessage = action.payload;
    },
    resetCreateDrmTableDataState: (state) => {
      state.isLoading = false;
      state.errorMessage = undefined;
      state.successMessage = undefined;
    },
  },
});

export const {
  setCreateDrmTableData,
  setCreateDrmTableDataSuccess,
  setCreateDrmTableDataFailure,
  resetCreateDrmTableDataState,
} = drmCreateTableDataSlice.actions;

export default drmCreateTableDataSlice.reducer;